export default __webpack_public_path__ + "static/m-fitness2-14226d12b28cc18c846d027321f47887.jpg";